/*
    Filter form for choosing which reassignment report records to retrieve from the DB

    Location, Route, Lane, Run, Vehicle are cascading values depending on the previous values
*/

import React from "react";

import LocationDropDown from "../Components/LocationDropDown";
import DateInput from "../Components/DateInput";
import TimeInput from "../Components/TimeInput";
import StyledCheckbox from "../Components/StyledCheckbox";
import MultiSelect from "../Components/MultiSelect";

import MainContext from "../MainContext";

import { getRoutes, getLanes, getRuns, getVehicleIDs } from "../Requests/UtilityRequests";
import { getUsers } from "../Requests/UserRequests";

/*
Location
Route (multi)
Run (multi)
Vehicle ID (multi)
Platform/Gate (multi)
Start DateTime
End DateTime
Show All Trips (check)
Driver Reassigned (check)
Starter Reassigned (check) (true)
*/

//
// the initial values for the filter,
// which can be used to reset it
//
function getDefaultState() {
    return {
        location: "ALL",
        startDate: new Date(),
        endDate: new Date(),
        startTime: "00:00",
        endTime: "23:59",
        // showAllTrips: false,
        // driverReassigned: false,
        allUsers: [],
        starter: "",
        trip_number: "",
        routes: [],
        routesSelected: [],
        runs: [],
        runsSelected: [],
        vehicleIDs: [],
        vehicleIDsSelected: [],
        lanes: [],
        lanesSelected: []
    };
}

export default class ReportReassignmentFilter extends React.Component {

    static contextType = MainContext;

    state = getDefaultState();

    //
    //
    updateValue = (evt) => {
        const targetName = evt.target.name;
        this.setState({[evt.target.name]: evt.target.value}, () => {
            if(targetName === "location"){
                this.locationSelected();
            }
        });
    }

    //
    //
    applyFilter = () => {
        const values = {...this.state};
        
        this.props.applyFilter(values, this.props.toggleFilter);
        this.context.updateReportFilter(values);
    }

    //
    //
    resetFilter = () => {
        this.setState(getDefaultState());
    }
    
    //
    // fill in the routes, runs, lanes, and vehicles
    // when the location is selected
    //
    locationSelected = () => {
        this.fillRoutes();
        this.fillRuns();
        this.fillLanes();
        this.fillVehicles();
    }

    //
    // fill in the runs, lanes, and vehicles
    // when the route is selected
    //
    routeSelected = () => {
        this.fillRuns();
        this.fillLanes();
        this.fillVehicles();
    }

    //
    // fill in the lanes and vehicles
    // when the run is selected
    //
    runsSelected = () => {
        this.fillLanes();
        this.fillVehicles();
    }

    //
    //
    fillRoutes = () => {
        const request = () => getRoutes(this.state.location);
        const then = ({data}) => {
            const cleaned = data.map(v => v.Route);
            cleaned.unshift("None");
            this.setState({routes: cleaned, routesSelected: []});
        };
        this.context.runProcessing(request, then, "getRoutes");
    }

    //
    //
    fillRuns = () => {
        const request = () => getRuns({
            location: this.state.location, 
            route: this.state.routesSelected.join(",")
        });
        const then = ({data}) => {
            const cleaned = data.map(v => v.Run);
            cleaned.unshift("None");
            this.setState({runs: cleaned, runsSelected: []});
        };
        this.context.runProcessing(request, then, "getRuns");
    }

    //
    //
    fillLanes = () => {
        const request = () => getLanes({
            location: this.state.location, 
            route: this.state.routesSelected.join(","), 
            runId: this.state.runsSelected.join(",")
        });
        const then = ({data}) => {
            const cleaned = data.map(v => v.laneGate);
            cleaned.unshift("None");
            this.setState({lanes: cleaned, lanesSelected: []});
        };
        this.context.runProcessing(request, then, "getLanes");
    }

    //
    //
    fillVehicles = () => {
        const request = () => getVehicleIDs({
            location: this.state.location, 
            route: this.state.routesSelected.join(""), 
            runId: this.state.runsSelected.join("")
        });
        const then = ({data}) => {
            console.log("VEHICLE IDs", data);
            const cleaned = data.map(v => v.vehicle_ID);
            cleaned.unshift("None");
            this.setState({vehicleIDs: cleaned, vehicleIDsSelected: []});
        };
        this.context.runProcessing(request, then, "getVehicleIDs");
    }

    fillUsers = () => {
        const request = () => getUsers({});
        const then = (({data}) => {
            console.log("ALL USERS", data);
            this.setState({allUsers: data});
        }); 
        this.context.runProcessing(request, then, "getUsers");
    }

    //
    // set the filter values
    //
    componentDidMount(){
        if(this.props.filterValues){
            console.log("REASSIGNMENT FILTER", this.props.filterValues);
            this.setState({...this.props.filterValues});
        }
        else if(this.context.reportFilterValues){
            //
            // if there were values previously used for this filter during this session,
            // restore them
            //
            console.log("WE HAVE REPORT VALUES", this.context.reportFilterValues);
            const copy = {...this.state};
            for(let key in copy) {
                if(this.context.reportFilterValues.hasOwnProperty(key)){
                    copy[key] = this.context.reportFilterValues[key];
                }
            }
            this.setState(copy);
        }

        this.fillVehicles();
        this.fillUsers();
    }

    render(){

        const isBus = this.context.user.groupid === "BUS";

        return (
            <div className="filter">
                <div className="form-element-horizontal">
                    <label>Location</label>
                    <LocationDropDown
                        setFocus={true}
                        selected={this.state.location} 
                        updateValue={this.updateValue}
                        hasAllOption={true} />
                </div>
                <div className="form-element-horizontal">
                    <label>Start Date</label>
                    <div>
                        <DateInput 
                            name="startDate"
                            value={this.state.startDate}
                            onChange={this.updateValue}
                        />
                        <TimeInput name="startTime" value={this.state.startTime} onChange={this.updateValue} />
                    </div>
                </div>
                <div className="form-element-horizontal">
                    <label>End Date</label>
                    <div>
                        <DateInput 
                            name="endDate"
                            value={this.state.endDate}
                            onChange={this.updateValue}
                        />
                        <TimeInput name="endTime" value={this.state.endTime} onChange={this.updateValue} />
                    </div>
                </div>
                <div className="form-element-horizontal">
                    <label>Starter</label>
                    {
                        /*
                        <input type="text" name="starter" value={this.state.starter} onChange={this.updateValue} />
                        */
                    }
                    <select style={{width: "300px"}} name="starter" value={this.state.starter} onChange={this.updateValue}>
                        <option value={""}>Select a User</option>
                    {
                        this.state.allUsers.map(u => {
                            return (
                                <option value={u.username}>{u.username}: {u.userfname} {u.usermname ? u.usermname : ""} {u.userlname}</option>
                            )
                        })
                    }
                    </select>
                </div>
                {
                    /*
                <div className="form-element-horizontal">
                    <label>Trip Number</label>
                    <input type="text" name="trip_number" value={this.state.trip_number} onChange={this.updateValue} />
                </div>
                    */
                }
                {
                    isBus
                    ? <div className="form-element-horizontal">
                        <label>Routes</label>
                        <MultiSelect 
                            name="routesSelected"
                            options={this.state.routes}
                            selected={this.state.routesSelected}
                            onChange={this.updateValue}
                            hasAllOption={true}
                            dataColumns={8}
                            onDone={this.routeSelected}
                        />
                    </div>
                    : null
                }
                <div className="form-element-horizontal">
                    <label>Runs</label>
                    <MultiSelect 
                        name="runsSelected"
                        options={this.state.runs}
                        selected={this.state.runsSelected}
                        onChange={this.updateValue}
                        hasAllOption={true}
                        dataColumns={8}
                        onDone={this.runsSelected}
                    />
                </div>
                {
                    /*
                <div className="form-element-horizontal">
                    <label>Vehicle IDs</label>
                    <MultiSelect 
                        name="vehicleIDsSelected"
                        options={this.state.vehicleIDs}
                        selected={this.state.vehicleIDsSelected}
                        onChange={this.updateValue}
                        dataColumns={8}
                        hasAllOption={true}
                    />
                </div>
                    */
                }
                {
                    isBus 
                    ? <div className="form-element-horizontal">
                        <label>Lanes</label>
                        <MultiSelect 
                            name="lanesSelected"
                            options={this.state.lanes}
                            selected={this.state.lanesSelected}
                            onChange={this.updateValue}
                            dataColumns={8}
                            hasAllOption={true}
                        />
                    </div>
                    : null
                }
                <div className="filter-bar">
                    <div className="option  " onClick={this.resetFilter}>Reset</div>
                    <div className="option  " onClick={this.applyFilter}>Apply Filter</div>
                </div>
            </div>
        )
    }
}